import { formatDate } from "@helpers/formatDate"
import { getCompanyLogo } from "@helpers/getCompanyLogo"
import { Button, IButtonProps, IconButton, ReportGeneratorDipai } from "@ui-lib/index"
import { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { MdAssignment } from "react-icons/md"

export default function ReportButtonCBM({
	isDisabled,
	reportName,
	dateFrom,
	dateTo,
	reportContents,
	listOfVessels,
	currentCompany,
	autoPrintKey,
	pdfTitle,
	onAfterPrint,
	buttonLabel,
	buttonVariant = "text-dark",
}: {
	isDisabled: boolean
	reportName: string
	dateFrom: Date
	dateTo: Date
	reportContents: ReactElement[]
	listOfVessels: string[]
	currentCompany: string | undefined
	autoPrintKey?: number | string
	pdfTitle?: string
	onAfterPrint?: () => void
	buttonLabel?: string
	buttonVariant?: IButtonProps["variant"]
}) {
	const { t } = useTranslation()
	const resolvedButtonLabel = buttonLabel ?? t("REPORT")
	return (
		<ReportGeneratorDipai
			randomIdKey={Math.random()}
			isDisabled={isDisabled}
			customerLogo={getCompanyLogo(currentCompany ?? "Unkown Company")}
			dipaiLogo={getCompanyLogo("dipai_white_yellow")}
			reportName={reportName}
			autoPrintKey={autoPrintKey}
			pdfTitle={pdfTitle}
			listOfVessels={listOfVessels}
			dateFrom={formatDate(dateFrom, "DD/MM/YYYY - HH:MM")}
			dateTo={formatDate(dateTo, "DD/MM/YYYY - HH:MM")}
			onAfterPrint={onAfterPrint}
		>
			{[
				...reportContents,
				<ReportGeneratorDipai.Trigger
					key={"trigger"}
					id="generate-report-button"
				>
					<Button
						className={`hidden px-3 xl:flex`}
						variant={buttonVariant}
						disabled={isDisabled}
					>
						<Button.Icon>{MdAssignment}</Button.Icon>
						<Button.Label>{resolvedButtonLabel}</Button.Label>
					</Button>
					<IconButton
						className={`flex xl:hidden`}
						size={"medium"}
						variant={buttonVariant}
						disabled={isDisabled}
					>
						<IconButton.Icon>{MdAssignment}</IconButton.Icon>
					</IconButton>
				</ReportGeneratorDipai.Trigger>,
				<ReportGeneratorDipai.TriggerOnLoading key={"triggerOnLoading"}>
					<Button
						className={`px-3`}
						variant={buttonVariant}
						disabled={isDisabled}
					>
						<svg
							className="h-4 w-4 animate-spin"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
						>
							<circle
								className="opacity-25"
								cx="12"
								cy="12"
								r="10"
								stroke="currentColor"
								strokeWidth="4"
							/>
							<path
								fill="currentColor"
								d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
							/>
						</svg>
						<Button.Label>{resolvedButtonLabel}</Button.Label>
					</Button>
				</ReportGeneratorDipai.TriggerOnLoading>,
			]}
		</ReportGeneratorDipai>
	)
}
